"use strict";
var onErrorResumeNext_1 = require('../operators/onErrorResumeNext');
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1143190010/src/~/rxjs/observable/onErrorResumeNext.js
// module id = 9mYp
// module chunks = 6